module.exports = __webpack_public_path__ + "img/gk3.ae53db6a.png";